import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./Dropdown.module.scss";

interface Props {
  dropdownData: any[];
  bindLabel: string;
  bindValue: string;
  selected:string;
  customClass?: string;
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}
const Dropdown: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`${props?.customClass} subTitle ${classes.form__control}`}>
      <select
        name={props.bindValue}
        className={classes.select}
        id={props.bindValue}
        value={props.selected}
        onChange={props.onChange}
      > 
        {props?.label && <option value={""}>--- Select {props?.label} ---</option> }
        {props.dropdownData.map((item, index) => (
          <option key={`${item[props.bindLabel] + index}`} value={item[props.bindValue]}>
            {t(`${item[props.bindLabel]}`)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
